import { useState, useEffect } from 'react';
import { Users, Award, Heart } from 'lucide-react';

export default function Stats() {
    const [counts, setCounts] = useState({ experience: 0, employees: 0, clients: 0 });

    useEffect(() => {
        const targets = { experience: 10, employees: 1360, clients: 8560 };
        const duration = 2000;
        const steps = 50;
        const stepDuration = duration / steps;

        let currentStep = 0;
        const timer = setInterval(() => {
            currentStep++;
            const progress = currentStep / steps;
            setCounts({
                experience: Math.floor(targets.experience * progress),
                employees: Math.floor(targets.employees * progress),
                clients: Math.floor(targets.clients * progress)
            });

            if (currentStep >= steps) {
                clearInterval(timer);
                setCounts(targets);
            }
        }, stepDuration);

        return () => clearInterval(timer);
    }, []);

    return (
        <section className="stats-section" data-testid="stats-section">
            <div className="container">
                <div className="stats-grid">
                    <div className="stat-item" data-testid="stat-experience">
                        <Award className="stat-icon" size={48} />
                        <div className="stat-number">{counts.experience}+</div>
                        <div className="stat-label">Years Experience</div>
                    </div>
                    <div className="stat-item" data-testid="stat-employees">
                        <Users className="stat-icon" size={48} />
                        <div className="stat-number">{counts.employees.toLocaleString()}+</div>
                        <div className="stat-label">Employees</div>
                    </div>
                    <div className="stat-item" data-testid="stat-clients">
                        <Heart className="stat-icon" size={48} />
                        <div className="stat-number">{counts.clients.toLocaleString()}+</div>
                        <div className="stat-label">Happy Clients</div>
                    </div>
                </div>
            </div>
        </section>
    );
};
